import { useAuthContext } from "./use-auth-context";

export const useAccountRole = () => {
  const authContext = useAuthContext();

  return authContext.account.org_role;
};
